import React from 'react';
import { LoadingSpinner } from '../../../atoms/LoadingSpinner';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export function ImageLoadingSpinner() {
  const { t } = useSonTranslation('Image');
  return (
    <p className="image__loading">
      <span className="invisible">{t('imageIsLoading')}</span>
      <span className="image__spinner">
        <LoadingSpinner />
      </span>
    </p>
  );
}
